<div>
  <h6 class="odx-title-6" i18n="@@global.referenceMeasure">Referenzmaß</h6>

  <app-floorplan-menu-item-buttons>
    <app-add-button
      (add)="addReferenceMeasure()"
      [odxTooltip]="tooltipTextAddMeasurement"
      [odxTooltipOptions]="{ position: 'bottom' }"
      (dragStart)="dragReferenceMeasure()"
      [disabled]="floorplanService.selectedFloorplan.referenceMeasure !== undefined"
    ></app-add-button>
    <app-toggle-visibility-button
      [visible]="floorplanState.referenceMeasureVisible"
      (toggleEvent)="floorplanState.referenceMeasureVisible = $event"
    >
    </app-toggle-visibility-button>
    <app-toggle-item-text-visibility-button
      [itemTextVisible]="floorplanState.referenceMeasureItemTextVisible"
      (toggleEvent)="updateReferenceMeasureItemTextVisibility($event)"
    ></app-toggle-item-text-visibility-button>
    <app-toggle-lock-button
      [locked]="floorplanState.referenceMeasureLocked"
      (toggleEvent)="floorplanState.referenceMeasureLocked = $event"
    >
    </app-toggle-lock-button>
  </app-floorplan-menu-item-buttons>
</div>
